import Http from '@/utils/http'

const TRANSACTION_ENDPOINT = '/transactions/'
const MAKE_PAYMENT = `${TRANSACTION_ENDPOINT}make-payment/`

export const makePayment = (data) => {
  return Http.post(MAKE_PAYMENT, data)
}

export const getTransactions = () => Http.get(TRANSACTION_ENDPOINT)

export const getTransaction = (trnxRef) => {
  return Http.get()
}

export const verifyPayment = (data) => {
  return Http.post(`${TRANSACTION_ENDPOINT}verify-payment/`, data)
}



// WEBPACK FOOTER //
// ./src/services/transaction.js